import axios from 'axios';
import { auth } from '../firebase';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL || 'http://localhost:5001/api',
  withCredentials: true,
});

// Add request interceptor to attach Firebase auth token
api.interceptors.request.use(
  async (config) => {
    const user = auth.currentUser;
    if (user) {
      try {
        const token = await user.getIdToken();
        config.headers.Authorization = `Bearer ${token}`;
      } catch (error) {
        console.error('Error getting auth token:', error);
      }
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Posts API methods
export const getPosts = (params) => api.get('/posts/feed', { params });
export const getCombinedFeed = (params) => api.get('/posts/feed-combined', { params });
export const getPost = (postId) => api.get(`/posts/${postId}`);
export const createPost = (data) => api.post('/posts', data);
export const updatePost = (postId, data) => api.put(`/posts/${postId}`, data);
export const deletePost = (postId) => api.delete(`/posts/${postId}`);
export const getUserPosts = (userId, params) => api.get(`/posts/user/${userId}`, { params });
export const getCampsitePosts = (campsiteId, params) => api.get(`/posts/campsite/${campsiteId}`, { params });

// Likes API methods
export const likePost = (postId) => api.post(`/likes/${postId}`);
export const unlikePost = (postId) => api.delete(`/likes/${postId}`);
export const checkLike = (postId) => api.get(`/likes/${postId}/check`);
export const likeContent = (contentType, contentId) => api.post(`/likes/${contentType}/${contentId}`);
export const unlikeContent = (contentType, contentId) => api.delete(`/likes/${contentType}/${contentId}`);
export const checkContentLike = (contentType, contentId) => api.get(`/likes/${contentType}/${contentId}/check`);

// Comments API methods
export const getComments = (postId, params) => api.get(`/comments/${postId}`, { params });
export const addComment = (postId, content) => api.post(`/comments/${postId}`, { content });
export const getContentComments = (contentType, contentId, params) => api.get(`/comments/${contentType}/${contentId}`, { params });
export const addContentComment = (contentType, contentId, content) => api.post(`/comments/${contentType}/${contentId}`, { content });
export const updateComment = (commentId, content) => api.put(`/comments/${commentId}`, { content });
export const deleteComment = (commentId) => api.delete(`/comments/${commentId}`);

// Auto-Booking API methods
export const getAutoBookings = () => api.get('/autoBooking');
export const getAutoBooking = (bookingId) => api.get(`/autoBooking/${bookingId}`);
export const cancelAutoBooking = (bookingId) => api.delete(`/autoBooking/${bookingId}`);

// Upload API methods
export const uploadPhoto = (file) => {
  const formData = new FormData();
  formData.append('photo', file);
  return api.post('/upload/photo', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
};

export const deletePhoto = (url) => api.delete('/upload/photo', { data: { url } });

// Search API methods
export const searchPosts = (params) => api.get('/search/posts', { params });

// Reviews API methods
export const getReviews = (params) => api.get('/reviews/feed', { params });
export const getReview = (reviewId) => api.get(`/reviews/${reviewId}`);
export const createReview = (data) => api.post('/reviews', data);
export const updateReview = (reviewId, data) => api.put(`/reviews/${reviewId}`, data);
export const deleteReview = (reviewId) => api.delete(`/reviews/${reviewId}`);
export const getUserReviews = (userId, params) => api.get(`/reviews/user/${userId}`, { params });
export const getFacilityReviews = (facilityId, params) => api.get(`/reviews/facility/${facilityId}`, { params });
export const getCampsiteReviews = (campsiteId, params) => api.get(`/reviews/campsite/${campsiteId}`, { params });

export default api;
